var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9 34.5h-8.7a8.7 8.7 0 002.5-6.2c0-5.3-4-9.3-9.3-9.3-3.1 0-8.7 2.8-12.4 6.5-3.7-3.7-9.3-6.5-12.4-6.5-5.3 0-9.3 4-9.3 9.3 0 2.5 1 4.6 2.5 6.2H22c-1.9 0-3.1 1.2-3.1 3.1v8.7c0 .3.3.6.6.6h26c.7 0 1.3-.6 1.3-1.2v-10c0-.6.6-1.2 1.2-1.2H52c.6 0 1.2.6 1.2 1.2v10c0 .6.6 1.2 1.2 1.2h26c.4 0 .7-.3.7-.6v-8.7c0-1.9-1.2-3.1-3.1-3.1zm-40.3-3.1c-1.9 0-3.1-1.2-3.1-3.1 0-1.9 1.2-3.1 3.1-3.1 1.9 0 7.4 3.7 9 5.6-1 .3-9 .6-9 .6zm24.8 0s-8-.3-9-.6c1.9-2.2 7.1-5.6 9-5.6 1.9 0 3.1 1.2 3.1 3.1 0 1.9-1.2 3.1-3.1 3.1zM45.7 53.1h-23c-.3 0-.6.3-.6.6V78c0 1.9 1.2 3.1 3.1 3.1h20.5c.6 0 1.2-.6 1.2-1.2V54.3c0-.6-.6-1.2-1.2-1.2zM77.3 53.1h-23c-.6 0-1.2.6-1.2 1.2v25.5c0 .6.6 1.2 1.2 1.2h20.5c1.9 0 3.1-1.2 3.1-3.1V53.7c0-.3-.3-.6-.6-.6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.aaab8b00.svg";
export { ForwardRef as ReactComponent };